import type { ReferenceImageItem } from '../api/referenceImages'
import { splitMasonryByShortestColumn } from './masonryColumnSplit'

export const LIBRARY_MASONRY_GAP_MOBILE_PX = 12
export const LIBRARY_MASONRY_GAP_DESKTOP_PX = 16

export type LibraryMasonryIndexedItem = {
  img: ReferenceImageItem
  listIndex: number
}

/** 主列过窄时强制单列（双列每列宽度过小易触发占位塌陷） */
export const LIBRARY_MASONRY_SINGLE_COL_MAX_PX = 340

/**
 * 仅移动端（viewport < lg）使用紧凑方卡占位。
 * 桌面窄主列（如 1100px）只减列数，仍保留 PC 卡片比例，避免破坏正常大屏逻辑。
 */
export function libraryMasonryLayoutCompact(viewportCompact: boolean): boolean {
  return viewportCompact
}

/**
 * 图库瀑布列数：与 Tailwind lg（1024px）及骨架 {@link MasonryListLoading} 对齐。
 * 仅当主列实测过窄时强制单列；否则桌面管理栏展开=2列、收起=3列。
 */
export function libraryMasonryColumnCount(opts: {
  /** viewport < lg */
  compact: boolean
  smUp: boolean
  managementPanelOpen: boolean
  /** 主滚动区 clientWidth；低于 {@link LIBRARY_MASONRY_SINGLE_COL_MAX_PX} 时单列 */
  mainColumnWidthPx?: number | null
}): number {
  if (opts.compact) return opts.smUp ? 3 : 2

  if (
    opts.mainColumnWidthPx != null &&
    opts.mainColumnWidthPx > 0 &&
    opts.mainColumnWidthPx < LIBRARY_MASONRY_SINGLE_COL_MAX_PX
  ) {
    return 1
  }

  return opts.managementPanelOpen ? 2 : 3
}

/** 按宽高比估算排序高度（仅需相对值） */
export function libraryMasonrySortHeight(img: ReferenceImageItem, compact: boolean): number {
  const w = img.width
  const h = img.height
  if (w != null && h != null && w > 0 && h > 0) return h / w
  return compact ? 1 : 1.25
}

/** 最短列贪心分列（与 {@link LibraryMasonrySkeleton} 一致） */
export function splitLibraryMasonryColumns(
  items: readonly ReferenceImageItem[],
  columnCount: number,
  gapPx: number,
  compact: boolean,
): LibraryMasonryIndexedItem[][] {
  const indexed: LibraryMasonryIndexedItem[] = items.map((img, listIndex) => ({
    img,
    listIndex,
  }))
  return splitMasonryByShortestColumn(
    indexed,
    columnCount,
    (entry) => libraryMasonrySortHeight(entry.img, compact),
    gapPx,
  )
}
